import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBack"><Path d="M16.6201 4.28588C17.6078 3.57309 19 4.27107 19 5.49633V18.5036C19 19.7288 17.6078 20.4268 16.6201 19.714L7.60855 13.2104C6.78175 12.6137 6.78175 11.3862 7.60855 10.7895L16.6201 4.28588Z" fill="currentColor"/><Path d="M5 4.54038C5 4.26424 5.22386 4.04038 5.5 4.04038C5.77614 4.04038 6 4.26424 6 4.54038V19.4595C6 19.7357 5.77614 19.9595 5.5 19.9595C5.22386 19.9595 5 19.7357 5 19.4595V4.54038Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBack;
